import MongoModel from './MongoModel'

export default class User extends MongoModel {
  modelName = 'User'
  collection = 'users'

  defaults () {
    return {
      id: null,
      user: null,
      email: null,
      currentOrganization: null,
      profile: {},
      preferences: {},
      plan: null
    }
  }
}
